// Fonte ÚNICA da detecção de tema do portal.
//
// O tema é aplicado de duas formas no app:
//  1. Classe CSS `.App.dark-mode` (App.js) — o padrão preferido: as telas
//     estilizam via CSS (ex.: Home.css, Financeiro.css).
//  2. Checagens inline em JS para estilos calculados — que antes liam
//     localStorage.getItem('login_theme') espalhado em centenas de pontos.
//
// Este helper centraliza o caso 2: mesma leitura, mesmo comportamento, um
// único lugar para manter (se a chave/critério do tema mudar, muda aqui).
export const isDarkMode = () => localStorage.getItem('login_theme') === 'dark'

export default isDarkMode
